export default __webpack_public_path__ + "static/media/member.0a839f48.png";